import Form from "./Form"
import { FormProvider } from '../../../context/FormContext'
import './index.css'

function MultiForm() {

    return (
        <><section className="content-header">
            <h1>Multi Form</h1>
        </section><section className="content">
                <div className="box">
                    <div className="box-body">
                        <FormProvider>
                            <Form />
                        </FormProvider>
                    </div>
                </div>
            </section></>
       
    )

}

export default MultiForm;